module.exports = __webpack_public_path__ + "static/media/support2.6a979053.svg";